











































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { apiSalarySettlementDetail, apiSalarySettlementPay } from '@/api/staff'

@Component
export default class SalarySettlementDetail extends Vue {
    detail: any = {}
    loading = false
    operationLogs: any[] = []

    get salaryItems () {
      return [
        { name: '基本工资', amount: this.detail.base_salary || 0, remark: '基础薪酬' },
        { name: '加班工资', amount: this.detail.overtime_salary || 0, remark: '加班费用' },
        { name: '提成金额', amount: this.detail.commission_amount || 0, remark: '业绩提成' },
        { name: '补贴金额', amount: this.detail.allowance_amount || 0, remark: '各项补贴' },
        { name: '其他金额', amount: this.detail.extra_amount || 0, remark: '其他收入' }
      ]
    }

    get deductionItems () {
      return [
        { name: '罚款金额', amount: this.detail.penalty_amount || 0, reason: '违规罚款' },
        { name: '转单费用', amount: this.detail.transfer_fee_amount || 0, reason: '转单产生费用' },
        { name: '个人所得税', amount: this.detail.tax_amount || 0, reason: '个税扣除' },
        { name: '社保公积金', amount: this.detail.social_insurance || 0, reason: '社保费用' },
        { name: '其他扣款', amount: this.detail.other_deductions || 0, reason: '其他扣款' }
      ]
    }

    getSalarySettlementDetail () {
      this.loading = true
      const id = this.$route.query.id
      if (!id) {
        this.$message.error('缺少结算单ID')
        this.$router.go(-1)
        return
      }

      apiSalarySettlementDetail({ id }).then((res: any) => {
        this.detail = res || {}

        const logs: any[] = [
          {
            create_time: this.detail.create_time,
            action: '生成结算单',
            operator: '系统',
            remark: '系统自动生成'
          }
        ]
        if (this.detail.confirmed_time) {
          logs.push({
            create_time: this.detail.confirmed_time,
            action: '确认结算',
            operator: this.detail.confirmed_by_name || '管理员',
            remark: '结算单已确认'
          })
        }
        if (this.detail.reviewed_time) {
          logs.push({
            create_time: this.detail.reviewed_time,
            action: '审核通过',
            operator: this.detail.reviewed_by_name || '财务',
            remark: this.detail.review_remark || ''
          })
        }
        if (this.detail.payment_time) {
          logs.push({
            create_time: this.detail.payment_time,
            action: '工资支付',
            operator: '财务',
            remark: `支付金额：${this.formatCurrency(this.detail.net_salary)}`
          })
        }
        // 按时间倒序，最新记录在上方
        this.operationLogs = logs.sort(
          (a, b) => this.parseTimestamp(b.create_time) - this.parseTimestamp(a.create_time)
        )
      }).finally(() => {
        this.loading = false
      })
    }

    handlePrint () {
      window.print()
    }

    handlePay () {
      this.$confirm(
        `确定支付该结算单？实发金额：${this.formatCurrency(this.detail.net_salary)}，将计入师傅可提现余额。`,
        '提示',
        { type: 'warning' }
      ).then(() => {
        apiSalarySettlementPay({ id: this.detail.id, payment_status: 2 }).then(() => {
          this.getSalarySettlementDetail()
        })
      })
    }

    formatCurrency (value: number): string {
      if (!value) {
        return '￥0.00'
      }
      return '￥' + Number(value).toFixed(2)
    }

    /** 统一解析接口时间：支持 Unix 秒、毫秒、或 YYYY-MM-DD HH:mm:ss 字符串 */
    parseTimestamp (value: number | string): number {
      if (value === null || value === undefined || value === '') {
        return 0
      }
      if (typeof value === 'string' && value.includes('-')) {
        const ms = new Date(value.replace(/-/g, '/')).getTime()
        return isNaN(ms) ? 0 : Math.floor(ms / 1000)
      }
      const ts = Number(value)
      if (!ts || isNaN(ts)) {
        return 0
      }
      return ts >= 1e12 ? Math.floor(ts / 1000) : ts
    }

    formatDate (value: number | string): string {
      const ts = this.parseTimestamp(value)
      if (!ts) {
        return '-'
      }
      const date = new Date(ts * 1000)
      if (isNaN(date.getTime())) {
        return '-'
      }
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
    }

    formatDateTime (value: number | string): string {
      const ts = this.parseTimestamp(value)
      if (!ts) {
        return '-'
      }
      const date = new Date(ts * 1000)
      if (isNaN(date.getTime())) {
        return '-'
      }
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
    }

    getSettlementStatusText (status: number): string {
      const statusMap = ['', '待确认', '已确认', '已审核', '已驳回']
      return statusMap[status] || '未知'
    }

    getSettlementStatusTagType (status: number): string {
      const typeMap = ['', 'warning', 'info', 'success', 'danger']
      return typeMap[status] || ''
    }

    getPaymentStatusText (status: number): string {
      const statusMap = ['', '待支付', '已支付', '支付失败']
      return statusMap[status] || '未知'
    }

    getPaymentStatusTagType (status: number): string {
      const typeMap = ['', 'warning', 'success', 'danger']
      return typeMap[status] || ''
    }

    created () {
      this.getSalarySettlementDetail()
    }
}
